import React from 'react'

import LayoutErrorPortlet from '../LayoutErrorPortlet'

export const NotFound = () => {
  return <LayoutErrorPortlet symbol="🛸" code="404" text="Not Found" />
}

export default NotFound
